import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule as ACommonModule } from '@angular/common';
import { ApiModule } from '../api';
import { TYTCommonModule } from '../common';

@NgModule({
  imports: [
    HttpClientModule,
    FormsModule,
    ACommonModule,
    ApiModule,
    TYTCommonModule
  ]
})
export class ModelsModule { 
  static forRoot(): ModuleWithProviders<ModelsModule> {
    return {
        ngModule: ModelsModule,
        providers: []
    };
}
}
